import {createSelector} from 'reselect'

export const selectFirstVerifyingCredential = (state) =>
  state.verifyingData &&
  state.verifyingData.creds &&
  (state.verifyingData.creds.find(({type}) => type === 'rambler-mail') ||
    state.verifyingData.creds[0])

export const selectIsPhoneSession = (state) =>
  state.verifyingData &&
  state.verifyingData.creds &&
  state.verifyingData.creds.length === 1 &&
  state.verifyingData.creds[0].subtype === 'phone'

export const selectIs2faEnabled = createSelector(
  selectFirstVerifyingCredential,
  (firstVerifyingCredential) =>
    firstVerifyingCredential && firstVerifyingCredential['2fa'] === 1
)

export const selectNeedPasswordConfirmation = createSelector(
  (state) => state.verifyingData && state.verifyingData.needCheck,
  selectFirstVerifyingCredential,
  (needCheck, firstVerifyingCredential) =>
    firstVerifyingCredential &&
    (firstVerifyingCredential.type === 'rambler-mail' ||
      firstVerifyingCredential.type === 'x-account') &&
    needCheck === 1
)

export const selectNeedPhoneConfirmation = createSelector(
  selectFirstVerifyingCredential,
  (firstVerifyingCredential) =>
    firstVerifyingCredential && firstVerifyingCredential.type === 'x-phone'
)
